export default __webpack_public_path__ + "static/media/who-02.b37aa461.png";